import { render, staticRenderFns } from "./BillingPlanDetailsForm.vue?vue&type=template&id=767cf6d2&scoped=true"
import script from "./BillingPlanDetailsForm.vue?vue&type=script&lang=js"
export * from "./BillingPlanDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767cf6d2",
  null
  
)

export default component.exports